// extracted by mini-css-extract-plugin
export const popularAccountListItem = "PopularProviders__popularAccountListItem__Rzap0";
export const popularProviders = "PopularProviders__popularProviders__qAXPR";